import 'babel-polyfill';

// REACT
import * as React from 'react';
import * as ReactDOM from 'react-dom';

// MATERIAL UI THEMES
import getMuiTheme from 'material-ui/styles/getMuiTheme';
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';

// STRIPE SETUP
import { StripeProvider } from 'react-stripe-elements';
import { stripePublicLiveKey, stripePublicTestKey } from './js/constants/index';

import Routes from './js/routes';
import { parallelLoad } from './js/utils/parallelLoad';
import registerServiceWorker from './registerServiceWorker';
import StoreProvider from './StoreProvider';

import { BrowserRouter as RouterProvider } from 'react-router-dom';
import { GlobalStyle } from './globalStyles';

import AuthProvider from './AuthProvider';
import MessagingProvider from './MessagingProvider';
import NotificationsProvider from './NotificationsProvider';
import ScreenDimensionProvider from './ScreenDimensionProvider';
import IdleMonitorProvider from './IdleMonitorProvider';
import BlurProvider from './BlurProvider';
import ToolbarSearch from 'components/ToolbarSearch/ToolbarSearch';

// SOME GLOBAL STYLES
import './globalStyles';

// LOAD ICONS FROM FONT AWESOME HERE - ONLY ONES THAT ARE NEEDED
import './js/icons/iconLibrary';

class App extends React.Component {
    render() {
        return (
            <RouterProvider>
                <StoreProvider>
                    <MuiThemeProvider
                        muiTheme={getMuiTheme(theme.muiGlobalThemeStyles)}
                    >
                        <StripeProvider
                            apiKey={
                                process.env.REACT_APP_ENV === 'production'
                                    ? stripePublicLiveKey
                                    : stripePublicTestKey
                            }
                        >
                            <div id="top">
                                <GlobalStyle />
                                <MessagingProvider />

                                <IdleMonitorProvider
                                    render={idleMonitor => (
                                        <AuthProvider
                                            idleMonitor={idleMonitor}
                                        />
                                    )}
                                />

                                <NotificationsProvider />

                                <BlurProvider>
                                    <ScreenDimensionProvider
                                        render={
                                            // tslint:disable-next-line jsx-no-lambda
                                            (width, height) => (
                                                <ToolbarSearch
                                                    screenWidth={width}
                                                />
                                            )
                                        }
                                    />

                                    <div
                                        style={{
                                            display: 'flex',
                                            flexDirection: 'column',
                                            justifyContent: 'space-between',
                                            overflow: 'hidden',
                                        }}
                                    >
                                        <Routes />
                                    </div>
                                    {/* FOOTER */
                                    /* <Toolbar style={{ height: 200, backgroundColor: 'rgb(52,52,52)', position: 'relative', width: '100%', bottom: 0 }} /> */}
                                </BlurProvider>
                            </div>
                        </StripeProvider>
                    </MuiThemeProvider>
                </StoreProvider>
            </RouterProvider>
        );
    }
}

parallelLoad(
    [
        'https://js.stripe.com/v3/',
        'https://static.opentok.com/v2/js/opentok.min.js',
    ],
    errs => {
        if (errs.length === 0) {
            const root = document.getElementById('root');
            ReactDOM.render(<App />, root);
        } else {
            throw new Error(errs);
        }
    },
);

registerServiceWorker();

const theme = {
    muiGlobalThemeStyles: {
        palette: {
            accent1Color:
                '#FFCC00' /* right now this only used to specify the badge colour */,
        },
    },
};



// WEBPACK FOOTER //
// ./src/index.tsx